module.exports = __webpack_public_path__ + "static/img/yingyong.2c96120.png";


//////////////////
// WEBPACK FOOTER
// ./static/qiuzhijiuye/yingyong.png
// module id = bFXM
// module chunks = 3